// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckboxField__container-fc6522 {
  --checkbox-field-gap: 8px;
}

.CheckboxField__content-c53dbf {
  display: flex;
  gap: var(--checkbox-field-gap);
}

.CheckboxField__has-error-b3accf .CheckboxField__message-de1746,
.CheckboxField__has-error-b3accf .CheckboxField__label-f24942 {
  color: var(--danger-40);
}

.CheckboxField__checkbox-f79acd {
  margin: 0;
  flex-shrink: 0;
}

.CheckboxField__label-f24942 {
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}

.CheckboxField__disabled-d4873d .CheckboxField__label-f24942 {
  color: var(--base-60);
}

.CheckboxField__message-de1746 {
  height: 16px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--base-80);
  padding: 4px 12px 0px 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/CheckboxField/CheckboxField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;;EAEE,uBAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,YAAA;EACA,2BAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AACF","sourcesContent":[".container {\n  --checkbox-field-gap: 8px;\n}\n\n.content {\n  display: flex;\n  gap: var(--checkbox-field-gap);\n}\n\n.has-error .message,\n.has-error .label {\n  color: var(--danger-40);\n}\n\n.checkbox {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.label {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.disabled .label {\n  color: var(--base-60);\n}\n\n.message {\n  height: 16px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--base-80);\n  padding: 4px 12px 0px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CheckboxField__container-fc6522`,
	"content": `CheckboxField__content-c53dbf`,
	"has-error": `CheckboxField__has-error-b3accf`,
	"hasError": `CheckboxField__has-error-b3accf`,
	"message": `CheckboxField__message-de1746`,
	"label": `CheckboxField__label-f24942`,
	"checkbox": `CheckboxField__checkbox-f79acd`,
	"disabled": `CheckboxField__disabled-d4873d`
};
module.exports = ___CSS_LOADER_EXPORT___;
